import React from "react";
import styles from "./KeyValueRow.module.css";

export default function KeyValueRow({
  label,
  value,
  align = "right", // left | center | right
  className = "",
  labelClassName = "",
  valueClassName = "",
}) {
  return (
    <div className={[styles.row, className].join(" ")}>
      <div className={[styles.label, labelClassName].join(" ")}>
        {label}
      </div>

      <div
        className={[
          styles.value,
          align === "left" ? styles.valueLeft : "",
          align === "center" ? styles.valueCenter : "",
          align === "right" ? styles.valueRight : "",
          valueClassName,
        ].join(" ")}
      >
        {value}
      </div>
    </div>
  );
}